import BaseAPI from './base.api';

export default class WeatherAPI extends BaseAPI {
  get = async () => {
    const response = await this.API.get(`weather`);
    return response.data;
  };
}
